export default {
  id: 'timesheet',
  title: 'Timesheet',
  category: 'Employee',
  summary: 'Enter hours against charge codes for the current pay period, then save and submit for approval.',
  overview: 'Your timesheet is organized by pay period. Each row is a charge code (task), and each column is a day. Enter hours worked, save your progress, and submit when the period is complete. Once submitted, your approver reviews the timesheet.',
  howItWorks: [
    'Timeclerk loads the pay period that contains today (or the period you navigate to).',
    'Charge codes assigned to you appear as rows. Add additional tasks with the Add Task button when needed.',
    'Enter hours for each day and charge code. Leave-related charge codes may also appear if leave tracking is enabled.',
    'Saving stores a draft without sending it for approval.',
    'Submitting locks the timesheet for editing and notifies your approver.',
    'If approved, the timesheet stays locked. If rejected, you can correct hours and resubmit.',
    'Requesting rejection on a submitted or approved timesheet asks your approver to unlock it so you can make changes.'
  ],
  actions: [
    {
      name: 'Previous / Next period',
      description: 'Moves between pay periods. Future periods beyond the current window may be disabled.'
    },
    {
      name: 'Calendar date picker',
      description: 'Jumps to the pay period that contains the selected date.'
    },
    {
      name: 'Add Task',
      description: 'Opens a dialog to add another charge code to this timesheet. If a needed task is missing, you can request it.'
    },
    {
      name: 'Out of Office',
      description: 'Schedules leave coverage for a date range. While active, manual edits may be blocked. You can allow Timeclerk to auto-submit the timesheet if you are out when the period ends.'
    },
    {
      name: 'Save',
      description: 'Persists your current entries as a draft. The timesheet remains editable and is not sent for approval.'
    },
    {
      name: 'Submit',
      description: 'Sends the timesheet to your approver. Status becomes Submitted and editing is locked until the approver acts or unlocks it.'
    },
    {
      name: 'Resubmit',
      description: 'Available after rejection. Sends your corrected timesheet back through the approval workflow.'
    },
    {
      name: 'Request Rejection',
      description: 'Available on submitted or approved timesheets. Asks the approver to reject so you can reopen and edit.'
    },
    {
      name: 'Export to PDF',
      description: 'Downloads a PDF snapshot of the current timesheet for your records.'
    }
  ],
  tips: [
    'Enter time daily when possible so you do not forget hours near period end.',
    'Expired or inactive charge codes may appear highlighted — do not charge new time to them.',
    'Check the summary panel to confirm daily and period totals before submitting.'
  ],
  related: ['leave', 'review', 'profile']
};



// WEBPACK FOOTER //
// ./client/help/content/timesheet.js